
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Einheit',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'units',
    initmutation:'units/UNIT_INIT_UNIT',
    backlink:'entities',
    duplicateable:true,
    helptext:"Hier werden Maßeinheiten (kg, gr etc.) eingegeben. (z.Zt. ist dieses Feature rein nachrichtlich) \n\
            <br><br> Der goldene Haken dient der Speicherung. Mit dem schwarzen Kreuz\n\
            wird ohne zu speichern das Formular verlassen. Mit dem Doppelhaken wird der Datensatz dupliziert."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};